// Module
var code = "<div aria-id=\"equipment-issued-component\"> <div class=\"panel panel-primary\"> <div class=\"panel-heading\"><b>Equipment Issued</b></div> <div class=\"panel-body\" style=\"overflow-x:hidden\"> <div class=\"row\"> <div class=\"col-md-12\"> <div id=\"jqxEquipmentIssuedGrid\"></div> </div> </div> </div> </div> </div>";
// Exports
export default code;